import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { PageLayout } from '@appbase/templates'

@Component({
  components: { PageLayout },
})
export default class AccountMaster extends Vue {}
